import { inject, Signal } from '@angular/core';
import { DialogService } from '@core/services/dialog.service';
import { Observable, of, switchMap } from 'rxjs';

export const pendingChangesGuard = (
  component: PendingChanges
): boolean | Observable<boolean> => {
  const dialog = inject(DialogService);

  const hasChanges = component.hasChanges();

  if (!hasChanges) {
    component.pendingChangesDiscard?.();
    return true;
  }

  return dialog
    .open({
      size: 'md',
      type: 'warning',
      title: 'General.Dialog.UnsavedChanges.Title',
      contentText: 'General.Dialog.UnsavedChanges.Text',
      confirmText: 'General.Save',
      cancelText: 'General.Discard',
    })
    .closed.pipe(
      switchMap(({ source }) => {
        switch (source) {
          case 'confirm':
            return component.pendingChangesSave();
          case 'close':
            return of(false);
          default:
            component.pendingChangesDiscard?.();
            return of(true);
        }
      })
    );
};
export interface PendingChanges {
  /** A function to check if it exists unsaved changes */
  hasChanges: (() => boolean) | Signal<boolean>;
  /** A function to execute save action when "save"
   * button is pressed on save changes dialog.
   * It must return Observable where true stands for success callback */
  pendingChangesSave: () => Observable<boolean>;
  /** Called before deactivating whenever the form isn't left dirty for the
   * user to act on — either there were no changes to begin with, or the
   * user discarded them from the dialog. Use it to reset the form's
   * dirty/touched state so it doesn't leak into the next entity shown by
   * a reused component instance. */
  pendingChangesDiscard?: () => void;
}
